import 'bootstrap/dist/css/bootstrap.min.css';
import * as Yup from 'yup';
import { useState, useRef, useMemo } from "react";
import { useDispatch } from "react-redux";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import { Col, Row } from 'react-bootstrap';
import { Button, IconButton, TextField, Grid, Chip, Box, FormGroup, FormControlLabel, Checkbox } from '@mui/material';
import { CloseIcon } from '@material-ui/data-grid';
import { firestore } from '../../config/firebaseConfig';
import { toast } from 'react-toastify';
import { Form, FormikProvider, FieldArray, useFormik } from 'formik'
import {
  getInventoryQuantity,
  AddQuatityForMonth,
  UpdateProductQuantityLeft
} from "../../redux/slices/inventory/inventory.thunks";
import { useInventory } from "../../context/InventoryContext";
import useToggle from "../../shared/functions/useToggle";
import {itemsCollection} from "../../constant";


export default function NewQtyForMonth({ pos = [], shipping = [], totalQuantity = 0, QuatityForMonth, ...rest }) {

  const ref = useRef()
  const { open, handleOpen, handleClose } = useToggle()


  const [isLoading, setisloading] = useState(true)
  const { hide, filters } = useInventory();
  const dispatch = useDispatch();

  // const telFormat = /^\d*(\.\d+)?$/
  const telFormat = /^[1-9]+/
  const formSchema = Yup.object().shape({
    QuatityForMonth: Yup.string().matches(telFormat, "La Quantité saisi est invalide").required("champs doit etre remplis"),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      QuatityForMonth: QuatityForMonth ?? 0,
    },
    validationSchema: formSchema,
    onSubmit: async (values, { setErrors, setSubmitting, resetForm }) => {
      var QuatityForMonth = values.QuatityForMonth
      const QtyData = {
        "QuatityForMonth": parseInt(QuatityForMonth)
      }
       console.log(values.QuatityForMonth)
       console.log(rest)

      try {

        dispatch(AddQuatityForMonth(rest.id, parseInt(QuatityForMonth), () => {
          dispatch(getInventoryQuantity(filters))
          let reff = itemsCollection.doc(rest.id);
          let quantityToBy;
          reff.get().then(function(doc) {
            if (doc.exists) {
              let value;
              value = doc.data().QuantityAvailable;
              console.log(value)
              let newQuantity = QuatityForMonth ;
              let newQ = newQuantity*3 - value
              console.log(newQ)
              quantityToBy = value > newQuantity*3 ? 0 : newQ
              dispatch(UpdateProductQuantityLeft(rest.id,quantityToBy))

            } else {
              console.log('No such document!');
            }
          }).catch(function(error) {
            console.log('Error getting document:', error);
          });

        }))

        setSubmitting(false);
        toast.success("success")
        resetForm();
        handleClose();
      } catch (error) {
        setSubmitting(false);
        toast.error("error");
        setErrors(error);
      }
    }
  })

  const {
    values,
    errors,
    touched,
    handleSubmit,
    getFieldProps,
  } = formik;



  return (
    <>
      <Box ref={ref}>
        <Chip
          label={QuatityForMonth || 0}
          onClick={handleOpen}
        />
        <Dialog open={open} anchorEl={ref.current} onClose={handleClose} maxWidth='sm' fullWidth >

          <DialogTitle>
            <Row>
              <Col className='col-auto text-truncate' style={{ display: 'grid', placeItems: 'center' }}>
                {"QUANTITY FOR MONTH"}
              </Col>
              <Col className='col-auto ml-auto'>
                <IconButton onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </Col>
            </Row>
          </DialogTitle>
          <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <DialogContent className='pt-4'>
                <Grid container spacing={2} columns={16}>
                  <Grid item xs={8} >
                    <TextField
                      label="QuatityForMonth"
                      variant="outlined"

                      error={Boolean(touched.QuatityForMonth && errors.QuatityForMonth)}
                      helperText={touched.QuatityForMonth && errors.QuatityForMonth}
                      {...getFieldProps('QuatityForMonth')}
                    />
                  </Grid>

                </Grid>
              </DialogContent>

              <DialogActions>
                <Button variant="contained" color='warning' onClick={handleClose}>
                  Cancel
                </Button>
                <Button variant='contained' color='primary' type="submit" setisloading={isLoading} >
                  Submit
                </Button>
              </DialogActions>
            </Form>
          </FormikProvider>

        </Dialog>
      </Box>

    </>
  )
}
